import { useContext } from "react";
import { useLocation } from "react-router-dom";
import { Outlet } from "react-router-dom";
import { Navigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const PrivateRoute = () => {
    const { isAuthenticated } = useContext(AuthContext);
    const location = useLocation();
  
    return (
      isAuthenticated === true ? (
        <Outlet />
      ) : (
        <Navigate to="/" state={{ from: location }} replace />
      )
    );
  };

export default PrivateRoute;